<template>
  <div>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.administratorList.push"
    :query-list="queryList"
    :is-show-store-select="isAdministrator"
    :is-store-select-clearable="true"
    :has-private-store="true"
    :is-show-search-input="true"
  >
    <v-column-time/>
    <el-table-column label="ID" prop="id" width="100px"/>
    <v-column-avatar/>
    <el-table-column label="所属门店">
      <template v-slot="{ row }">{{ row.store_names | formatStoreName }}</template>
    </el-table-column>
    <el-table-column label="账号" prop="username"/>
    <el-table-column label="手机号" prop="phone"/>
    <el-table-column label="最后登录">
      <template v-slot="{ row }">
        <template v-if="row.last_login_time">{{ row.last_login_time | timeToYmdHi }}</template>
        <span v-else>-</span>
      </template>
    </el-table-column>

    <el-table-column label="企业微信号">
      <template v-slot="{ row }">
        <span>{{ row.we_chat }}</span>
      </template>
    </el-table-column>

    <el-table-column v-if="isAdministrator || isManager" label="操作" width="310px">
      <template v-slot="{ row }">
        <v-list-button v-if="isAdministrator" name="编辑资料" size="large" :to="RouteConfig.administratorEdit.to(row.id)"/>
        <v-list-button v-if="isAdministrator" name="移至门店" size="large" :to="RouteConfig.administratorSalaryAdd.to(row.id)"/>
        <v-list-button v-else-if="isManager" name="离职办理" size="large" :is-loading="isOffboarding[row.id]" @click="openOffboard(row)"/>
        <v-list-button v-else-if="isManager" icon="view" name="任职记录" size="large" @click="openPersonnel(row)"/>

        <v-popover v-if="isAdministrator">
          <v-popover-item name="修改密码" :to="RouteConfig.administratorEditPasswordByAdministrator.to(row.id)"/>
          <v-popover-item name="离职办理" :is-loading="isOffboarding[row.id]" @click="openOffboard(row)"/>
          <v-popover-item icon="view" name="任职记录" @click="openPersonnel(row)"/>
          <v-popover-item icon="bin" name="账号清理" @click="handleDelete(row)" :is-loading="isDeleting[row.id]" message="仅用于无在职记录的账号清理，确认要继续吗？"/>
        </v-popover>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`administrator-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>管理员ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>管理员昵称</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_names | formatStoreName }}</span>
            </div>

            <div class="list-item-detail">
              <span>账号</span>
              <span>{{ v.username }}</span>
            </div>

            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone }}</span>
            </div>

            <div class="list-item-detail">
              <span>企业微信号</span>
              <span>{{ v.we_chat }}</span>
            </div>


            <div v-if="isAdministrator || isManager" class="list-item-button">
              <v-list-button v-if="isAdministrator" name="编辑资料" size="large" :to="RouteConfig.administratorEdit.to(v.id)"/>
              <v-list-button v-if="isAdministrator" name="移至门店" size="large" :to="RouteConfig.administratorSalaryAdd.to(v.id)"/>
              <v-list-button v-else-if="isManager" name="离职办理" size="large" :is-loading="isOffboarding[v.id]" @click="openOffboard(v)"/>
              <v-list-button v-else-if="isManager" icon="view" name="任职记录" size="large" @click="openPersonnel(v)"/>

              <v-popover v-if="isAdministrator">
                <v-popover-item name="修改密码" :to="RouteConfig.administratorEditPasswordByAdministrator.to(v.id)"/>
                <v-popover-item name="离职办理" :is-loading="isOffboarding[v.id]" @click="openOffboard(v)"/>
                <v-popover-item icon="view" name="任职记录" @click="openPersonnel(v)"/>
                <v-popover-item icon="bin" name="账号清理" @click="handleDelete(v)" :is-loading="isDeleting[v.id]" message="仅用于无在职记录的账号清理，确认要继续吗？"/>
              </v-popover>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>

  <el-dialog :title="offboardDialogTitle" :visible.sync="offboardDialogVisible" width="460px">
    <el-alert
      v-if="offboardDialogTip"
      :title="offboardDialogTip"
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom: 12px;"
    />
    <el-form ref="offboardForm" :model="offboardForm" :rules="offboardRules" label-width="100px">
      <el-form-item label="员工">
        <span>{{ offboardTarget.nickname }}</span>
      </el-form-item>
      <el-form-item label="所属门店" prop="store_id">
        <v-select-store class="w100" v-model="offboardForm.store_id" :has-private="true" :disabled="!isAdministrator"/>
      </el-form-item>
      <el-form-item label="离职类型">
        <el-select v-model="offboardForm.leave_type" class="w100">
          <el-option v-for="item in leaveTypeOptions" :key="item.value" :label="item.name" :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="离职原因" prop="leave_reason">
        <el-input v-model="offboardForm.leave_reason" type="textarea" :rows="3" maxlength="255" show-word-limit/>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="offboardDialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="offboardSaving" @click="submitOffboard">{{ offboardSubmitText }}</el-button>
    </div>
  </el-dialog>

  <v-dialog-personnel
    v-model="personnelDialogVisible"
    :administrator-id="personnelDialogAdministratorId"
    @updated="load"
  />
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index, destroy, show } from '@/api/administrator';
import { offboardApplyStore } from '@/api/personnel';
import { leaveTypes } from '@/enums/leaveTypes';
import { getLegalQueryList } from '@/utils/formats';
import VDialogPersonnel from '@/components/VDialogPersonnel/index.vue';

export default {
  name: RouteConfig.administratorList.name,
  components: {
    VDialogPersonnel,
  },
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    queryList: {
      store_id: '',
      is_asc: 0,
      page: 1,
      size: 10,
      keyword: '',
    },
    isLoading: false,
    isDeleting: {},
    // 打开离职办理弹窗前要先拉一次管理员详情，按 id 锁住按钮防止重复请求
    isOffboarding: {},
    offboardDialogVisible: false,
    offboardSaving: false,
    personnelDialogVisible: false,
    personnelDialogAdministratorId: 0,
    offboardTarget: { nickname: '', isSuper: false },
    offboardForm: {
      administrator_id: 0,
      store_id: 0,
      leave_type: 1,
      leave_reason: '',
    },
    offboardRules: {
      store_id: [{ required: true, message: '请选择所属门店', trigger: 'change' }],
      leave_reason: [{ required: true, message: '请填写离职原因', trigger: 'blur' }],
    },
    leaveTypeOptions: Object.values(leaveTypes),
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isManager',
      'defaultStoreId',
    ]),
    isOffboardDirect() {
      return this.isAdministrator && !this.offboardTarget.isSuper;
    },
    offboardDialogTitle() {
      return this.isOffboardDirect ? '办理离职' : '发起离职申请';
    },
    offboardDialogTip() {
      if (this.isOffboardDirect) {
        return '该员工不是超级管理员，确认后将立即办理离职，无需等待审核。';
      }
      if (this.isAdministrator) {
        return '该员工为超级管理员，提交后将由另一名超级管理员审核。';
      }
      return '提交离职申请后，将交由超级管理员审核。';
    },
    offboardSubmitText() {
      return this.isOffboardDirect ? '确认办理' : '提交申请';
    },
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;

      if (next) next();
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
    },
    openPersonnel(row) {
      this.personnelDialogAdministratorId = row.id;
      this.personnelDialogVisible = true;
    },
    async openOffboard(row) {
      if (this.isOffboarding[row.id]) return;

      this.$set(this.isOffboarding, row.id, true);
      this.offboardTarget = { nickname: row.nickname || '', isSuper: false };
      this.offboardForm.administrator_id = row.id;
      this.offboardForm.store_id = this.isAdministrator ? 0 : this.defaultStoreId;
      this.offboardForm.leave_type = 1;
      this.offboardForm.leave_reason = '';
      this.offboardDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.offboardForm) this.$refs.offboardForm.clearValidate();
      });

      const { isError, data } = await show(row.id);
      this.$set(this.isOffboarding, row.id, false);
      if (!isError) {
        const roleIds = data.role_ids || [];
        this.offboardTarget.isSuper = roleIds.some((id) => Number(id) === 1);
        if (data.store_ids && data.store_ids.length === 1) {
          this.offboardForm.store_id = this.isAdministrator ? data.store_ids[0] : (this.defaultStoreId || data.store_ids[0]);
        }
      }
    },
    submitOffboard() {
      if (this.offboardSaving) return;
      this.$refs.offboardForm.validate(async (isSuccess) => {
        if (!isSuccess) return;
        this.offboardSaving = true;
        const { isError, data } = await offboardApplyStore(this.offboardForm);
        this.offboardSaving = false;
        if (isError) return;
        this.offboardDialogVisible = false;
        this.$message.success(data && data.is_direct ? '离职已直接办理' : '离职申请已提交');
        this.load();
      });
    },
    async handleDelete({ id }) {
      if (!id) return;

      try {
        const { value } = await this.$prompt('请输入注销原因（1~120字符）', '账号清理', {
          confirmButtonText: '确定清理',
          cancelButtonText: '取消',
          inputValidator: (value) => (value && value.trim() ? true : '请输入注销原因'),
        });

        this.$set(this.isDeleting, id, true);
        const { isError } = await destroy(id, { delete_cause: value.trim() });
        this.$set(this.isDeleting, id, false);
        if (isError) return;

        this.$message.success('已注销，可在回收站还原');
        this.load();
      } catch (e) {
        // 用户取消
      }
    },
  },
};
</script>
